import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    var thisElement = this.element
    $(thisElement).sortable({
      axis: 'y',
      items: '> .sort-row',
      handle: '.drag-handle',
      update: function(e, ui) {
        update_function(e, ui);
      }
    });
  }

  disconnect() {
  }
}
